import React from 'react'
import Icon from 'atoms/Icon'

export const actionFormatter4 = (cell, row, rowIndex, formatExtraData) => {
  const { allowEdit, edit, color, allowDel, del } = formatExtraData
  return (
    <div>
      {allowEdit && (
        <Icon
          icon={'edit'}
          ml={'15%'}
          color={color || '#00b4a5'}
          onClick={edit(row)}
          showPointer={true}
        />
      )}
      {allowDel && (
        <Icon
          icon={'trash-alt'}
          ml={'15%'}
          color={'red'}
          onClick={del(row, rowIndex)}
          showPointer={true}
        />
      )}
    </div>
  )
}
